import {hasReducedMotion} from "../utils/a11y";

interface CounterInterface {
	container: HTMLElement;
	animate(): void;
	handleIntersection( entries: IntersectionObserverEntry[] ): void;
	renderValue( value: number ): void;
}

export const initCounterBlock = ( el: HTMLElement ): CounterInterface => {
	const Object = {
		config: {
			threshold: 0.5,
		},
		container: el,
		data: {
			from: Number( el.dataset.countFrom ) ?? 0,
			to: Number( el.dataset.countTo ) ?? 100,
			duration: Number( el.dataset.countDuration ) ?? 1000,
			start: 0,
		},
		observer: null as IntersectionObserver|null,

		_init: function () {
			console.log( 'Init Counter: ', this.container, this.data);

			this._bindClass();
			this._connectObserver();
		},

		_bindClass(): void {
			this.animate = this.animate.bind(this);
			this.handleIntersection = this.handleIntersection.bind(this);
			this.renderValue = this.renderValue.bind(this);
		},

		_connectObserver(): void {
			this.observer = new IntersectionObserver(
				this.handleIntersection,
				{
					threshold: this.config.threshold
				}
			)

			this.observer?.observe( this.container );
		},

		_disconnectObserver(): void {
			this.observer?.disconnect();
		},

		animate(): void {
			if ( hasReducedMotion() ) {
				this.renderValue( this.data.to );
				return;
			}

			const frame = ( timestamp: number ) => {
				if ( ! this.data.start ) {
					this.data.start = timestamp;
				}

				const progress: number = Math.min( ( timestamp - this.data.start ) / this.data.duration, 1 );
				const current: number  = Math.floor( progress * ( this.data.to - this.data.from ) + this.data.from );

				if (progress < 1) {
					this.renderValue( current );
					requestAnimationFrame( frame );
				}
				else {
					this.renderValue( this.data.to );
				}
			};

			requestAnimationFrame( frame );
		},

		handleIntersection( entries: IntersectionObserverEntry[] ): void {
			entries.forEach( (entry: IntersectionObserverEntry ): void => {
				if ( entry.isIntersecting ) {
					this.animate();
					this._disconnectObserver();
				}
			} );
		},

		renderValue( value: number ): void {
			const valueEl = this.container.querySelector( '.counter__value' ) as HTMLElement|null;

			if ( ! valueEl ) {
				return;
			}

			valueEl.innerHTML = value.toString();
		},

	};

	Object._init();
	return Object;
};

export const initCounterBlocks = ( selectors = '.counter' ): void => {
	const blocks = document.querySelectorAll( selectors ) as NodeListOf<HTMLElement>;

	blocks.forEach(
		( el: HTMLElement ) => initCounterBlock( el )
	);
};
